import { render, staticRenderFns } from "./AppUpdateDialog.vue?vue&type=template&id=56f5284e&scoped=true"
import script from "./AppUpdateDialog.vue?vue&type=script&lang=js"
export * from "./AppUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./AppUpdateDialog.vue?vue&type=style&index=0&id=56f5284e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5284e",
  null
  
)

export default component.exports